import React, { useState } from "react";
import styled from "styled-components";
import SizeItem from "../../Shared/SizeItem";
import { ASSETS } from "../../../../utils/config.js";

const Container = styled.div`
  padding-bottom: 20px;
  border-bottom: 1px solid #f7f2fa;
  margin-top: 15px;
`;

const RowDiv = styled.div`
  display: flex;
  align-items: center;
  margin-top: -5px;
`;

const TitleHeading = styled.p`
  font-size: 16px;
  color: #000000;
  font-family: DM Sans;
  font-weight: 500;
`;

function AlignmentBox({ isLeftAlignment, handleAlignment }) {
  return (
    <Container>
      <TitleHeading>Alignment</TitleHeading>
      <RowDiv>
        <SizeItem
          title={"Left"}
          isSelected={isLeftAlignment}
          image={ASSETS.segmentEditor.LeftAlign}
          onClick={() => handleAlignment("right")}
        />
        <SizeItem
          title={"Right"}
          isSelected={!isLeftAlignment}
          image={ASSETS.segmentEditor.RightAlign}
          onClick={() => handleAlignment("left")}
        />
      </RowDiv>
      {/**<RowDiv>
        <SizeItem
          title={"Top"}
          // isSelected={!isLeftAlignment}
          image={ASSETS.segmentEditor.RightAlign}
          onClick={() => handleAlignment("top")}
        />
        <SizeItem
          title={"Bottom"}
          // isSelected={isLeftAlignment}
          image={ASSETS.segmentEditor.LeftAlign}
          onClick={() => handleAlignment("bottom")}
        />
      </RowDiv>**/}
    </Container>
  );
}

export default AlignmentBox;
